module.exports = __webpack_public_path__ + "/build/web/images/matching-pillows@2x.617337442a2bf399137e0581f8e57171.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/matching-pillows@2x.jpg
// module id = 174
// module chunks = 13